<div [ngClass]="{ 'tw-border-b tw-border-gray-200': !isLast() }">
  <button
    type="button"
    class="tw-w-full tw-flex tw-items-center tw-justify-between tw-p-2 tw-text-left"
    (click)="toggle()"
    [attr.aria-expanded]="isExpanded()"
  >
    <span class="tw-font-inter tw-text-base tw-font-bold tw-text-gray-900">{{ title() }}</span>

    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="accordion-chevron"
      [ngClass]="{ expanded: isExpanded() }"
      aria-hidden="true"
    >
      <g clip-path="url(#clip0_47652_90058)">
        <path
          d="M12.6026 11.0674C12.2318 11.0673 11.8762 10.9241 11.614 10.6694L7.0091 6.19599L2.40422 10.6694C2.27523 10.7991 2.12092 10.9026 1.95032 10.9738C1.77971 11.045 1.59621 11.0825 1.41053 11.084C1.22486 11.0856 1.04072 11.0512 0.868863 10.9829C0.697007 10.9146 0.540875 10.8137 0.409577 10.6862C0.278279 10.5587 0.174444 10.407 0.104132 10.24C0.0338205 10.0731 -0.00156068 9.8942 5.27988e-05 9.71383C0.00166628 9.53345 0.0402425 9.3552 0.11353 9.18946C0.186818 9.02373 0.29335 8.87383 0.42691 8.74852L6.02044 3.31473C6.28268 3.06006 6.6383 2.91699 7.0091 2.91699C7.3799 2.91699 7.73552 3.06006 7.99776 3.31473L13.5913 8.74852C13.7868 8.9385 13.9199 9.18052 13.9739 9.444C14.0278 9.70747 14.0001 9.98057 13.8943 10.2288C13.7885 10.4769 13.6093 10.6891 13.3794 10.8384C13.1495 10.9876 12.8792 11.0673 12.6026 11.0674Z"
          fill="#9CA3AF"
        />
      </g>
      <defs>
        <clipPath id="clip0_47652_90058">
          <rect width="14.0007" height="14.0007" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </button>

  <div class="accordion-body" [class.expanded]="isExpanded()" [attr.aria-hidden]="!isExpanded()">
    <div class="accordion-body-inner">
      <ng-content />
    </div>
  </div>
</div>
